import { get } from 'lodash';

import {
  readerConnectSuccess,
  selectReader,
  selectReaderDone,
} from '../register/webReader/actions';
import { webreaderError } from './actions';
import apiTerminal from './ApiTerminal';
import webTerminal from './Terminal';
import { getNormalizedErrorMessage, shouldShowError } from './helpers';
import { showNotification } from '../common/helpers/notifications';
import { getIsProcessorMode } from '../register/webReader/selector';

class SharedStrategy {
  constructor(name) {
    this.name = name;
    this.isApiReader = false;
  }

  getName() {
    return this.name;
  }

  setIsApiReader(isApiReader) {
    this.isApiReader = isApiReader;
  }

  selectReaderDone(readers, dispatch) {
    dispatch(selectReaderDone(readers[0], this.getName()));
  }

  selectReader(readers, dispatch) {
    dispatch(selectReader(readers, this.getName()));
  }

  readerConnectSuccess(dispatch) {
    dispatch(readerConnectSuccess(this.getName()));
  }

  readerConnectError(error, dispatch) {
    dispatch(webreaderError({ error, config: { position: 'tc' } }, this.getName()));
  }

  dispose() {
    const canUseApiTerminal = this.isApiReader && this.getName() === 'pay';
    const terminal = canUseApiTerminal ? apiTerminal : webTerminal;

    terminal.dispose(this.getName());
  }

  // eslint-disable-next-line class-methods-use-this
  handleWebreaderError(state, action) {
    if (!shouldShowError(action.payload.error) || getIsProcessorMode(state)) {
      return;
    }

    showNotification({
      title: 'Error',
      level: 'error',
      message: getNormalizedErrorMessage(action.payload.error),
      position: 'tr',
      ...get(action, 'payload.config', {}),
    });
  }
}

export default SharedStrategy;
